import { NumberFilterOperationType } from 'module/types/filter-field/filter/number';
import { FormattedMessage } from 'react-intl';

export const numberTriggerOptionRenderers = (
  operationType: NumberFilterOperationType,
): null | React.JSX.Element => {
  switch (operationType) {
    case NumberFilterOperationType.IsGreaterThan: {
      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_greater_than" />
      );
    }
    case NumberFilterOperationType.IsLessThan: {
      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_less_than" />
      );
    }
    case NumberFilterOperationType.Is: {
      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is" />
      );
    }
    case NumberFilterOperationType.IsEmpty: {
      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_empty" />
      );
    }
    case NumberFilterOperationType.IsNotEmpty: {
      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_not_empty" />
      );
    }
    default: {
      return null;
    }
  }
};
